import AlertSystem from "@/components/AlertSystem.vue";
import { Formatter } from "@/utils/currencyFormatter.js";
import { date, picker, formatDate } from "@/utils/dateFormatter.js";
import { system } from "@/shared/messages/system.json"
import { big_headers } from "@/shared/constants/big_headers.json"
import moment from "moment";

export default {
  name: 'Faturas',
  components: {
    AlertSystem,
  },
  computed: {
    computedDateFormatted() {
      return formatDate(this.dataPagamento);
    },
  },
  data() {
    return {
      messages: {
        title: system.src.views.Sebraetec.registrar_baixa.title,
        pesquisar: system.src.views.generic.search,
        filtrarStatus: system.src.views.generic.filter_status,
        filtrarUnidade: system.src.views.generic.filter_unit,
        formaPagamento: system.src.views.generic.type_payment,
        limparFiltros: system.src.views.generic.clean_filters,
        baixa_manual: system.src.views.generic.manually_register_certification,
        baixa: system.src.views.generic.register_certification,
        anexo: system.src.views.generic.attachment,
        data_pagamento: system.src.views.generic.payment_date,
        observacao: system.src.views.generic.note
      },
      rangeMin: moment().format("YYYY-MM-DD"),
      rangeMax: moment().add(30, "days").format("YYYY-MM-DD"),
      headers: big_headers.src.views.Sebraetec.registrar_baixa.headers.main,
      system:{
        snackbar: {},
        modalRegistrarBaixa: false,
      },
      faturamentos: [],
      tiposStatus: big_headers.src.views.Sebraetec.registrar_baixa.headers.status,
      MenuDataPagamento: picker,
      tiposPagamento: [],
      search: '',
      status: 1,
      loadFatura: false,
      dataPagamento: date,
      myloadingvariable: false,
      unidadesList: [],
      dataInicialFatura: '',
      dataFinalFatura: '',
      menuDataInicial: false,
      menuDataFinal: false,
      today: '2020-09-16',
      atualDay:'2020-09-16',
      statusSelecionado: null,
      FaturaDataVencimento: null,
      unidadeSelecionada: null,
      formadePagamento: null,
      tipoPagamentoSelecionado: null,
      anexoFormaPagamento: null,
      faturaunicageral: [],
      faturaunica: {
        idFatura: null,
        valor: null,
        vencimento: null,
        IdFormaPagamento: null,
      },
      observacaoPagamento: null,
      Observacao: null,
      files: null,
      snackbar: false,
      filelist: null,
      object: null
    } 
  },
  methods: {
    async getUnidades() {
      const { data } = await this.axios('unidades')
      this.unidadesList = data
    },
    getFaturamentos () {
      this.loadFatura = true
      this.axios.get('/faturamentos/getSebraetec', {
        params:{
          IdSituacao: this.statusSelecionado,
          IdUnidade: this.unidadeSelecionada          
        }
      }).then( res => {
        this.faturamentos = res.data.filter(element => {
          element.RazaoSocial = this.prepareNameFilter(element.RazaoSocial)
          return element;
        })
      }).finally(() => {
        this.loadFatura = false;
      })
    },
    registrarbaixa(){
      if (this.faturaunica.IdFormaPagamento == null || this.files.length == 0 || this.dataPagamento == null) {
        this.system.snackbar = {
          snackbar: true,
          text: "Preencha todos os campos obrigatorios",
          color: "red",
        };
      } else{
        let formData = new FormData();
        formData.append('TipoPagamento', this.faturaunica.IdFormaPagamento)
        formData.append('Observacao', this.observacaoPagamento)
        formData.append('DataPagamento', this.dataPagamento)
        formData.append('NotaFiscalNumero', this.object.NotaFiscalNumero)
        formData.append('NotaFiscalNumero', this.object.ValorFaturado)
        formData.append('files', this.files)
        this.axios.post('/faturamentos/sebraetec_registrar_baixa', formData)
        .then( res => {
          this.system.snackbar = {
            snackbar: true,
            text: res.data.message,
            color: "green",
          };
          this.system.modalRegistrarBaixa = !this.system.modalRegistrarBaixa
        }).catch(e => {
          this.system.snackbar = {
            snackbar: true,
            text: e.response.data,
            color: "red",
          };
        })
      }
    },
    limparFiltros(){
      this.statusSelecionado = null
      this.search = null
      this.unidadeSelecionada = null
      this.getFaturamentos();
    },

    zerarCampos(){
      this.files = [];
      this.faturaunica.IdFormaPagamento = null;
      this.observacaoPagamento = null;
      this.dataPagamento = null;
      this.faturaunica.valor = null;
    },

    getFormasPagamento(){
      this.axios.get('/faturamentos/formasPagamento')
        .then( res => {
          this.tiposPagamento = res.data.filter(element => {
            if(element.IdFormaPagamento != 1){
              return {
                IdFormaPagamento: element.IdFormaPagamento,
                FormaPagamento: element.FormaPagamento,
                BaixaManual: element.BaixaManual,
              }
            }
          })
        })
    },

    formatPrice(value) {
      return Formatter(value)
    },
  },
  mounted() {
    this.today = this.$moment().format('YYYY-MM-DD')
    this.atualDay = this.$moment().format('YYYY-MM-DD')    
    this.getFaturamentos()
    this.getUnidades()
  }
}